export default __webpack_public_path__ + "static/media/dolby.9bd5b36f.png";